import { Section, NextBar, In, Sel } from "./Fields";
import { INSPECTION_TYPES, STATUSES } from "./constants";

export default function JobStep({ jobForm, setJobForm, onPrev, onNext }) {
  return (
    <Section title="Inspection job" subtitle="Type, date, inspector and status.">
      <div className="grid md:grid-cols-2 gap-4">
        <Sel label="Inspection type" v={jobForm.inspection_type} on={(v) => setJobForm({ ...jobForm, inspection_type: v })} opts={INSPECTION_TYPES} test="wizard-job-type" />
        <Sel label="Status" v={jobForm.status} on={(v) => setJobForm({ ...jobForm, status: v })} opts={STATUSES} />
        <In label="Inspection date" type="date" v={jobForm.inspection_date} on={(v) => setJobForm({ ...jobForm, inspection_date: v })} test="wizard-job-date" />
        <In label="Inspector name" v={jobForm.inspector_name} on={(v) => setJobForm({ ...jobForm, inspector_name: v })} test="wizard-job-inspector" />
        <In label="Move-in date" type="date" v={jobForm.move_in_date} on={(v) => setJobForm({ ...jobForm, move_in_date: v })} />
        <In label="Move-out date" type="date" v={jobForm.move_out_date} on={(v) => setJobForm({ ...jobForm, move_out_date: v })} />
      </div>
      <NextBar onPrev={onPrev} onNext={onNext} testId="wizard-next-3" />
    </Section>
  );
}
